<template>
  <div class="bg-white vform position-relative">
    <div v-show="loading" class="load-bg">
      <span v-show="loading">
        <i class="spin ml-4" />
      </span>
    </div>
    <div class="row m-4 justify-content-center">
      <div class="col-lg-9 bg-white py-4">
        <div class="container mt-4 pt-4">
          <navigate-user-back />

          <div class="text-center mt-4 pt-4">
            <div>{{ $t('message.loyaltyStamps') }}</div>
            <div v-if="dbuser">{{(dbuser.RewardPoints?dbuser.RewardPoints:0)| formatNumber}}</div>
          </div>
          <hr />
        </div>
        <div v-if="getFirstValidRedemptionRule" class="container mb-4 mt-4 justify-content-center">
          <div class="row justify-content-center mb-4">{{getLoyalityMessage}}</div>
          <div width="300" class="row justify-content-center">
            <canvas id="circleContainer"></canvas>
            <div :style="desktopStyles.CommonColorTxt" class="inner-shape">
              <i class="fa fa-heart"></i>
            </div>
          </div>
          <div
            class="row justify-content-center mb-0"
            style="margin-top:-20px;margin-left: -25px;"
          >{{(dbuser.RewardPoints?dbuser.RewardPoints>getFirstValidRedemptionRule.Point?getFirstValidRedemptionRule.Point:dbuser.RewardPoints:0)}}/{{getFirstValidRedemptionRule.Point}}</div>
          <hr />
        </div>
        <div class="container">
          <div v-for="(order, index) in pageOrders" :key="index" class="row">
            <div class="row col-sm-12 order-items ml-5">
              <div class="order-item-details col-sm-7">
                <div>{{ $t('message.orderNo') }}.</div>
                <div>{{(order.OrderNumber?'#':'')}}{{order.OrderNumber}}</div>
              </div>
              <div class="col-sm-4 text-right mr-5">
                <div class="color-gray fdate" v-html="getCreateDate(order)" />
                <div class="order-item-cost padding-5-left">
                  <span>&nbsp;({{(order.TotalExcludingTax + order.TotalTax) | formatMoney(currencySign)}})</span>
                  <span
                    class="text-red"
                    v-if="order && order.RedeemPoints>0"
                  >&nbsp;-{{order.RedeemPoints | formatNumber}} {{ $t('message.stamps') }}</span>
                  <span
                    class="text-success"
                    v-if="order && order.RewardPoints>0"
                  >&nbsp;+{{order.RewardPoints | formatNumber}} {{ $t('message.stamps') }}</span>
                </div>
              </div>
            </div>
            <div class="col-sm-12">
              <hr />
            </div>
          </div>
          <div v-if="pageOrders.length == 0">
            <message :message="getNoOrderAvailable" />
          </div>
        </div>
        <div class="order-pagination">
          <pagination
            v-model="page"
            :records="records"
            :per-page="perPage"
            :options="options"
            @paginate="paginateCallback"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "vue-pagination-2";
import shared from "../../sharedscripts/user/Loyalty.js";
import Message from "./../shared/Message";
import { mapGetters } from "vuex";
import { interpolate } from "../../api/helpers/stringHelper";
import NavigateUserBack from "@/components/user/partials/navigateUserBack";
export default {
  components: {
    NavigateUserBack,
    Pagination,
    Message
  },
  data() {
    return {
      page: 1,
      perPage: 3,
      records: 0,
      options: {
        theme: "bootstrap4",
        chunksNavigation: "scroll",
        texts: {
          count: "",
          prev: "prev"
        }
      },
      orders: [],
      pageOrders: [],
      loading: false,
      error: "",
      success: false,
      storeClosed: false
    };
  },
  computed: {
    ...shared.computed,
    ...mapGetters([
      "desktopStyles",
      "currentStoreDoc",
      "getFirstValidRedemptionRule"
    ]),
    getNoOrderAvailable() {
      return this.$t("message.noOrderAvailable");
    },
    getLoyalityMessage() {
      return interpolate(
        this.$t("message.collectGetFree"),
        this.getFirstValidRedemptionRule.Point,
        this.getFirstValidRedemptionRule.Name
      );
    }
  },
  watch: {
    user(newValue) {
      if (newValue) {
        this.initOrders(this.currentStoreDoc.ID);
      }
    }
  },
  created() {
    if (this.user) {
      this.initOrders(this.currentStoreDoc.ID);
    }
  },
  mounted() {
    this.setStoreLoaded();
    this.drawCircle(this.desktopStyles.alertInfoBackGround.background);
  },
  methods: {
    ...shared.methods
  }
};
</script>
